import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Title, Button } from '@qonsoll/react-design'
import {
  StyledFilter,
  StyledHeader,
  filterBackground,
  filterMaxHeight,
  iconStyles,
  buttonProps
} from './CustomerFilter.styles'
import { CloseOutlined } from '@ant-design/icons'
import {
  ApplicationFilter,
  RepresentativeFilter,
  DatabaseFilter,
  FeatureFilter,
  MockupFilter,
  OfferFilter,
  CustomerProfileFilter
} from './components'

const CustomerFilter = (props) => {
  const { filterVisibility, setFilterVisibility, filterData, setFilterData } =
    props

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const handleClose = () => setFilterVisibility(false)

  return filterVisibility ? (
    <>
      <StyledHeader background={filterBackground}>
        <Title mb={2} level={4}>
          {t('Filter')}
        </Title>
        <Button
          {...buttonProps}
          onClick={handleClose}
          icon={<CloseOutlined style={iconStyles} />}
        />
      </StyledHeader>
      <StyledFilter maxHeight={filterMaxHeight} background={filterBackground}>
        <ApplicationFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <RepresentativeFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <DatabaseFilter filterData={filterData} setFilterData={setFilterData} />
        <FeatureFilter filterData={filterData} setFilterData={setFilterData} />
        <MockupFilter filterData={filterData} setFilterData={setFilterData} />
        <OfferFilter filterData={filterData} setFilterData={setFilterData} />
        <CustomerProfileFilter
          filterData={filterData}
          setFilterData={setFilterData}
        />
      </StyledFilter>
    </>
  ) : null
}

CustomerFilter.propTypes = {
  filterVisibility: PropTypes.bool,
  setFilterVisibility: PropTypes.func,
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default CustomerFilter
